module.exports = __webpack_public_path__ + "static/media/rsScreenShot06.1f6a03ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press/rsScreenShot06.png
// module id = 577
// module chunks = 0